import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomSelect } from '../../select/custom/custom-select/custom.select';

import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import { LegendElement } from '../../legenda/legenda.component';

export class CustomColumn
{
  isId            ?: boolean
  label            : string
  name             : string
  display         ?: Function
  style_filter    ?: Function
  pipe            ?: Function
  translate_param ?: any = {}
  params          ?: string[]
  group           ?: string
}

export class CustomColumnGroup{
  id              : string
  name            : string
  size            : Function
  calc_size      ?: number
  calc_isFirst   ?: boolean = null
  calc_isLast    ?: boolean = null
}

export class CustomButton
{
  display?: Function
  label   : string
  column  : string
  name    : string | Function
  action  : Function
  active ?: Function
  pipe   ?: Function
}

export class CustomIconButton
{
  label   : string
  column  : string
  icon    : string
  tooltip : string
  action  : Function
  pipe   ?: Function
  display ?: Function = () => true
}

export class HeaderButton
{
  label    : string
  name     : string
  action   : Function
  pipe    ?: Function
  display ?: Function = () => true
}

export class ChartConfiguration
{
  id        : string
  labels    : LabelConf
  columns   : CustomColumn[]
  type      : string
  scales   ?: any
  tooltips ?: any
}

export class LabelConf {
  name    ?: string
  isColumn: boolean = false
}

export class PDFExportButton
{
  label    : string
  name     : string
  config   : PDFExportConfig
  display ?: Function = () => true
}

export class PDFExportConfig
{
  filename    : Function
  columnsRule : Function
  rowsRule    : Function
}

export class RowStyleFilter
{
  rule              : Function
  style             : any
  color            ?: string
  text             ?: string
  group            ?: string
}

@Component({
  selector: 'custom-table',
  templateUrl: './custom-table.component.html',
  styleUrls: ['./custom-table.component.scss']
})
export class CustomTableComponent implements OnInit, OnChanges {

  filterSelect: CustomSelect
  @ViewChild("filterSelect") set _filterSelect(filterSelect: CustomSelect){
    if (filterSelect)
    setTimeout ( () => this.filterSelect = filterSelect, 0)
  }

  @Input()  table_id          : string
  @Input()  title_none        : string
  @Input()  title_single      : string
  @Input()  title_multiple    : string
  @Input()  no_title_value    : string

  @Input()  values: any[]

  @Input()  columns: CustomColumn[]
  @Input()  groups : CustomColumnGroup[]

  @Input()  no_filter_row : boolean = false
  @Input()  filter_title  : string
  @Input()  filter_columns: boolean = true
  @Input()  paginator     : boolean = true

  @Input()  buttons           : CustomButton    []
  @Input()  icon_buttons      : CustomIconButton[]
  @Input()  header_buttons    : HeaderButton    []

  @Input()  parent            : any

  @Input()  create            : boolean         = false
  @Input()  create_text       : string          = "tables.generic.action.create"

  @Input()  delete_slot       : boolean         = false
  @Input()  delete_slot_text  : string          = "tables.generic.action.delete_slot"

  @Input()  update            : boolean         = false
  @Input()  update_text       : string          = "tables.generic.action.update"
  @Input()  update_text_title : string          = "tables.generic.action.update"

  @Input()  delete            : boolean         = false
  @Input()  delete_text       : string          = "tables.generic.action.delete"
  @Input()  delete_text_title : string          = "tables.generic.action.delete"

  @Input()  search_placeholder: string          = "tables.generic.search.placeholder"
  @Input()  search_title      : string          = "tables.generic.search.title"

  @Input()  no_data           : string          = "tables.generic.no_data"
  @Input()  loading_data      : string          = "tables.generic.loading_data"

  @Input()  reloadable        : boolean         = false
  @Output("refresh")  refresh : EventEmitter<void> = new EventEmitter<void>()

  @Input()  chartsConf        : ChartConfiguration []
  @Input()  pdf_buttons       : PDFExportButton    []

  @ViewChild('customTable', { static: false }) table: ElementRef;

  @Input()  row_styles        : RowStyleFilter    []
  @Input()  legenda           : LegendElement     []


  visibleColumns              : CustomColumn[]

  collectionSize              : number

  pageSize                    : number = 6
  page                        : number = 1

  rows                        : any[]

  reload                      : boolean = false
  firstLoading                : boolean = true

  row_text_filter             : string  = ""

  labels                      : string[]

  constructor(
    private _translate: TranslateService
  ) { }

  ngOnInit(): void
  {
    if(localStorage.getItem('pageSize')) this.pageSize = parseInt(localStorage.getItem('pageSize'))

    if(localStorage.getItem(this.table_id + 'page'  )) this.page = parseInt(localStorage.getItem(this.table_id + 'page'))
  }

  ngOnChanges(changes: SimpleChanges)
  {
    if (changes && changes.values) {
      const values = changes.values

      if (values && ( !values.isFirstChange() || values.currentValue != values.previousValue ) ){

        // Da rimuovere se ci sono problemi con la paginazione ->
        this.page = parseInt(localStorage.getItem(this.table_id + 'page'));
        this.page = this.page ? this.page : 1
        let maxPage = Math.ceil(this.values.length/this.pageSize)
        if(this.page > maxPage) this.page = maxPage
        // <-

        this.filterRows()
      }

      setTimeout( () => this.evaluateGroup() , 100 )

    }
  }

  getTitle(): string
  {
    if (this.title_none     ) return this.title_none
    if (this.title_single   ) return this.title_single
    if (this.title_multiple ) return this.title_multiple

    return null
  }

  generateColumns()
  {
    let columns = []
    this.columns.forEach( ( col ) => {
      if(col.display == undefined || col.display()){
        columns.push(col)
      }
    })
    return columns
  }

  getfilteredColumns(){
    let columns = []
    this.columns.forEach( ( col ) => {
      if(col.display == undefined || col.display()){
        columns.push(col)
      }
    })
    return columns
  }


  getIdColumn(){
    return this.columns.find( col => col.isId)
  }

  getRows(){
    let rows = []

    const values = [].concat(this.values)
    values.forEach( (value) => {
      rows.push ( this.generateRow ( value ) )
    })
    return rows
  }

  generateRow (value: any)
  {
    let row = []

    if(!this.visibleColumns) return row

    this.visibleColumns.forEach( column => {
      let find = false
      for ( let key in value ){
        if ( column.label == key )
        {
          row.push(value[key])
          find = true
          break
        }
      }
      if (!find) row.push( null )

    })

    const idCol = this.getIdColumn()
    if ( idCol ) {
      for ( let key in value ){
        if ( idCol.label == key )
        {
          row.unshift(value[key])
          break
        }
      }
    }

    return row
  }

  extractColumns(value: any, name: string){
    if (value)
      if (value[name])
        return value[name]
  }

  // = = = = = = = = = = = = = = = = = = = = = = = = = = = = = =

  pipeData ( index: number, value: any, row_i: number, test?: boolean) {
    let column = this.visibleColumns[index]
    if(test){
      console.log(column);
    }
    if ( !column || ! column.pipe ) return value

    const piped = column.pipe(value, row_i)
    return piped
  }

  pipeButtonData(row: any[], index: number, value: any)
  {
    if (!this.buttons) return null
    if (!row) return value.name

    let button = this.buttons[index]
    if ( !button || ! button.pipe ) return value.name
    const piped = button.pipe(row)
    return piped
  }

  styleFilter(index: number, value: any){
    let column = this.visibleColumns[index]
    if ( !column || ! column.style_filter ) return
    const style = column.style_filter(value)
    return style
  }

  rowStyleFilter(index: number, table_row: any){
    let style = {}
    if (!this.row_styles || this.row_styles.length == 0) return style

    const row = this.values.find ( val => val.id == table_row[0])
    if (!row) return style

    const style_i = this.row_styles.findIndex( row_s => row_s.rule( index, row ) )

    if (style_i > -1) {
      style = this.row_styles[style_i].style
    }

    return style
  }

  test(index: number, value: any)
  {
    const filter: CustomColumn[] = this.filterSelect.getSelectedValue()
  }

  // = = = = = = = = = = = = = = = = = = = = = = = = = = = = = =

  getLength(): number
  {
    if ( !this.values || !this.values[0] ) return -1
    return this.values.length
  }

  hasLabel(){
    return this.title_none || this.title_single || this.title_multiple
  }

  // = = = = = = = = = = = = = = = = = = = = = = = = = = = = = =

  filterColumns(columns: CustomColumn[])
  {
    if    (this.filter_columns) setTimeout ( () => this.visibleColumns = columns, 0)
    else  setTimeout ( () => this.visibleColumns = this.generateColumns(), 0)

    //localStorage.setItem(this.table_id + 'filter', JSON.stringify(this.visibleColumns));

    this.filterRows()
    setTimeout ( () => this.evaluateGroup(), 100)

  }

  // = = = = = = = = = = = = = = = = = = = = = = = = = = = = = =

  showPaginator(){


    const v = this.filter_text( this.getRows(), this.row_text_filter)

    if  ( !this.paginator ) {
      this.page = 0
      return false
    }
    if  ( v  &&  v.length && v.length > 6) return true

    return false
  }

  showPages(){
    if  ( !this.paginator ) return false

    if  ( this.getSize () / this.pageSize <= 1) return false

    return true
  }


  getMaxSize()
  {
    const v = this.filter_text( this.getRows(), this.row_text_filter)

    if ( v  &&  v.length )
      if  ( v.length > 2) return 2
      else                          return v.length

    return 0
  }

  getSize () {
    const v = this.filter_text( this.getRows(), this.row_text_filter)

    if ( v  &&  v.length)
      return v.length
    return 0
  }

  filterRows()
  {
    setTimeout ( () => this.rows = this.textFilter(), 0)
  }

  textFilter (text_filter?: string)
  {
    if(!text_filter)
      text_filter = this.row_text_filter

    let par_rows = this.getRows()

    if(!text_filter || text_filter.trim() == "")
      this.rows = this.filter_paginator(par_rows)
    else
      this.rows = this.filter_text(par_rows, text_filter, this.columns.length == 11)


    return this.rows
  }

  filterPaginator()
  {
    return this.filter_paginator(this.getRows())
  }

  filter_paginator(array: any[]){
    if ( !array ) return []

    if ( array.length  < (this.page - 1) * this.pageSize )
      this.page = array.length / this.pageSize

    return array.filter ( row => {
      const index = array.indexOf(row)
      if ( index >= (this.page - 1) * this.pageSize && index < this.page * this.pageSize )
        return row
    })
  }

  filter_text (array: any[], text: string, test? : boolean)
  {
    if ( !array ) return []
    return array.filter( (row) => {

      for ( var i = 1 ; i < row.length; i ++){

        var value = String(this.pipeData(i-1, row[i], i))
        if (value && isNaN(+value))
        {
          try{
            value = this._translate.instant(value)
          }catch(error) { }
        }

        if (!value) value = ""
        if (!text ) return row

        value = value.toLowerCase()
        text  = text.toLowerCase()

        if ( value.indexOf(text) >= 0 || value == text ) return row
      }
    })
  }

  pageChange(change: any)
  {
    localStorage.setItem(this.table_id + 'page', this.page.toString());
    this.filterRows()
  }

  paginatorChange(change: any)
  {
    localStorage.setItem('pageSize', this.pageSize.toString());
    this.filterRows()
  }

  public reloadData()
  {
    this.reload = true
    this.values = []
  }

  public dataLoaded()
  {
    if (this.firstLoading) this.firstLoading = false

    this.reload = false
  }

  // = = = = = = = = = = = = = = = = = = = = = = = = = = = = = =

  can (operation: string)
  {
    if (!this.parent) return false

    switch(operation)
    {
      case "create"     : return this.create      && this.create_text
      case "update"     : return this.update      && this.update_text
      case "delete"     : return this.delete      && this.delete_text
    }
    return false
  }

  // = = = = = = = = = = = = = = = = = = = = = = = = = = = = = =

  table_create ( ) {
    this.parent.create ()
  }

  table_delete_slot()
  {
    this.parent.delete_all_slot()
  }

  table_update ( el: any ) {

    const real_el  = this.values.find( val => val.id == el[0])

    console.log( real_el );

    if (!real_el) return

    console.log( real_el );

    this.parent.update (real_el)

  }

  table_delete ( el: any ) {

    const real_el  = this.values.find( val => val.id == el[0])

    if (!real_el) return

    this.parent.delete (real_el)

  }

  call_action( but: CustomButton, el: any)
  {
    const pos = this.values.indexOf( val => val.id == el[0])

    const real_el  = this.values.find( val => val.id == el[0])

    if (!real_el || !pos ) return

    but.action(real_el, pos)
  }

  emptyTable(){
    return !this.values || this.values.length == 0
  }

  isFirstLoading()
  {
    return this.firstLoading
  }

  refreshTable(){
    this.refresh.emit()
  }

  displayHeaderButton(button: HeaderButton)
  {
    return button.display()
  }

  disableIconButton(button: CustomIconButton, table_row: any)
  {
    if(!button.display) return false

    const row = this.values.find ( val => val.id == table_row[0])
    if (!row) return true
    return !button.display( row )
  }

  clickHeaderButton(button: HeaderButton){
    return button.action()
  }

  displayPdfButton(button: PDFExportButton)
  {
    return button.display ? button.display() : true
  }

  clickPdfButton(button: PDFExportButton){

    const doc = new jsPDF();

    const head    = this.extractTableColumns ( button.config )
    const indexes = this.extractColumnIndexes( button.config )
    const rows    = this.extractTableRows    ( button.config , indexes )

    autoTable(doc, {
      head: [head],
      body: rows,
      styles: { halign: 'center' },
    })

    const title = button.config.filename()
    doc.save( title )
  }

  extractColumnIndexes ( config: PDFExportConfig) {
    let indexes = []
    if (!this.columns) return indexes
    let i = 0
    this.columns.forEach  ( (column) =>{
      if ( config.columnsRule(column)) {
        try {
          indexes.push( i )
        }catch(error){}
      }
      i = i + 1
    })
    return indexes
  }

  extractTableColumns ( config: PDFExportConfig) {
    let columns = []
    if (!this.columns) return columns
    this.columns.forEach  ( (column) =>{
      if ( config.columnsRule(column)) {
        try {
          const translate = this._translate.instant (column.name)
          columns.push( translate )
        }catch(error){}
      }
    })
    return columns
  }

  extractTableRows    ( config: PDFExportConfig, indexes: number[]) {
    let rows = []
    if (!indexes || indexes.length == 0) return rows
    const table_rows = this.getRows()
    if (!table_rows) return rows
    table_rows.forEach  ( (table_row) =>{
      const row = this.values.find ( val => val.id == table_row[0])
      if (row) {
        if ( config.rowsRule(row)) {
          let filtered_row = []
          indexes.forEach ( i => {
            filtered_row.push( table_row[i] )
          })
          rows.push( filtered_row )
        }
      }
    })
    return rows
  }


  evaluateGroup()
  {
    if ( !this.groups) return

    for( let i = 0 ; i < this.groups.length ; i++ ){
      const group = this.groups[i]
      group.calc_size = group.size(this.visibleColumns)

    }

    let active_groups = this.groups.filter( group => group.calc_size > 0 ).length

    console.log( "There are " , active_groups , "active groups");


    for( let i = 0 ; i < this.groups.length ; i++ ){
      const group = this.groups[i]
      const pos = this.getGroupPos( group )
      console.log( group.id , pos );
      if( pos == 0 )  group.calc_isFirst = true
      else            group.calc_isFirst = false

      if( pos + 1 == active_groups )  group.calc_isLast = true
      else                            group.calc_isLast = false

    }

  }

  getGroupSize( group: CustomColumnGroup){
    if ( !group) return 0

    return group.calc_size ? group.calc_size : 0
  }

  getGroupPos(group: CustomColumnGroup){
    if ( !this.groups || !group ) return 0

    let pos = null

    for ( let i = 0 ; i < this.groups.length ; i++ ) {
      const g =  this.groups[i]
      if ( g.calc_size > 0 ) {
        if  (pos == null)  pos = 0
        else        pos = pos + 1
      }

      if( g.id == group.id )
        return pos

    }

    return null
  }

  isLastGroup( group: CustomColumnGroup ){
    return group ? group.calc_isLast != null ? group.calc_isLast : true : true
  }

  isFirstGroup( group: CustomColumnGroup ){
    return group ? group.calc_isFirst != null ? group.calc_isFirst : true : true
  }

  isLastOfGroup( pos: number ){
    pos = pos + 1
    let sl_window = 0
    if(!this.groups) return false
    for( let i = 0 ; i < this.groups.length; i++){
      const group = this.groups[i]
      sl_window += group.calc_size
      if(pos <= sl_window)
      {
        const pos_in_group =  ( sl_window - pos )

        if( pos_in_group == 0)  return !group.calc_isLast
      }
    }
    return false
  }

  getButtonName( name: string | Function, index: number ){
    try{
      const el = this.rows[index]
      const pos = this.values.indexOf( val => val.id == el[0])

      const real_el  = this.values.find( val => val.id == el[0])

      if (!real_el || !pos ) return
      name = name as Function
      return name ( real_el , pos);
    }catch( error ){
      return name
    }
  }

  displayButton(button: CustomButton, index: number )
  {
    if(!button || !button.display)
      return true

    const el = this.rows[index]
    const pos = this.values.indexOf( val => val.id == el[0])

    const real_el  = this.values.find( val => val.id == el[0])

    if (!real_el || !pos ) return true
    return button?.display(real_el , pos )
  }

  isButtonActive(button: CustomButton, index: number)
  {
    if(!button || !button.active)
      return true

    const el = this.rows[index]
    const pos = this.values.indexOf( val => val.id == el[0])

    const real_el  = this.values.find( val => val.id == el[0])

    if (!real_el || !pos ) return true

    return button?.active( real_el , pos )
  }
}

export function addIdsToArray(array: any[]) : any[]
{
  if (!array) return []

  let id = 0
  array.forEach(column => {
    column.id = id
    id = id + 1
  })

  return array
}
